"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmSubmit = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NBTConfirm = _interopRequireDefault(require("./NBTConfirm"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ConfirmSubmit = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ConfirmSubmit, _Component);
  var _super = _createSuper(ConfirmSubmit);
  function ConfirmSubmit() {
    (0, _classCallCheck2.default)(this, ConfirmSubmit);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(ConfirmSubmit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        headerText = _this$props.headerText,
        isAdsOffer = _this$props.isAdsOffer,
        _this$props$applicati = _this$props.application,
        id = _this$props$applicati.id,
        firstName = _this$props$applicati.firstName,
        lastName = _this$props$applicati.lastName,
        loanAmount = _this$props$applicati.loanAmount,
        payment = _this$props$applicati.payment,
        term = _this$props$applicati.term,
        rate = _this$props$applicati.rate,
        employerTooltipMsg = _this$props.employerTooltipMsg,
        submitApplication = _this$props.submitApplication,
        selectPlanRedirect = _this$props.selectPlanRedirect,
        formatNumberWithComma = _this$props.formatNumberWithComma,
        submitBtnText = isAdsOffer ? 'Confirm and Apply' : 'Confirm and Submit';
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("main", {
        className: "pf-confirm-submit-content main-content",
        role: "main"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "header-text"
      }, /*#__PURE__*/_react.default.createElement("h1", null, headerText), /*#__PURE__*/_react.default.createElement("div", {
        className: "privacy-security-logo"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "privacy-security pull-right"
      }))), /*#__PURE__*/_react.default.createElement(_NBTConfirm.default, {
        id: id,
        firstName: firstName,
        lastName: lastName,
        loanAmount: loanAmount,
        payment: payment,
        term: term,
        rate: rate,
        employerTooltipMsg: employerTooltipMsg,
        submitBtnText: submitBtnText,
        selectPlanRedirect: selectPlanRedirect,
        submitApplication: submitApplication,
        formatNumberWithComma: formatNumberWithComma
      })));
    }
  }]);
  return ConfirmSubmit;
}(_react.Component);
exports.ConfirmSubmit = ConfirmSubmit;
(0, _defineProperty2.default)(ConfirmSubmit, "defaultProps", {
  headerText: 'Just a few more details to confirm before submitting:',
  isAdsOffer: false,
  employerTooltipMsg: "If you have more than one job, simply use the one that you consider your primary occupation.\n    This will not impact the offer you've already selected.",
  application: {
    firstName: '',
    lastName: '',
    loanAmount: 0,
    payment: 0,
    term: 0,
    rate: 0
  },
  formatNumberWithComma: function formatNumberWithComma(n) {
    return n;
  }
});
ConfirmSubmit.propTypes = {
  isAdsOffer: _propTypes.default.bool.isRequired,
  application: _propTypes.default.object.isRequired,
  employerTooltipMsg: _propTypes.default.string,
  headerText: _propTypes.default.string,
  selectPlanRedirect: _propTypes.default.string,
  submitApplication: _propTypes.default.func,
  formatNumberWithComma: _propTypes.default.func
};
